<template>
    <b-card class="edit-hub-details-form">
        <b-form @submit.prevent="updateData">
            <b-row>
                <b-col md="6" cols="12">
                    <b-form-group label="Hub Name:" label-cols-xl="2">
                        <b-form-input
                        v-model="form.name"
                        placeholder="Enter name"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group label="Hub Manager:" label-cols-xl="2">
                        <el-select v-model="form.hub_manager" required filterable placeholder="Select Hub Manager">
                            <el-option v-for="option in selectHubManagerOptions"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </b-form-group> 
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group label="Address:" label-cols-xl="2">
                        <b-form-textarea
                        v-model="form.address"
                        placeholder="Enter address..."
                        required
                        rows="3"
                        max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group label="Target (RM):" label-cols-xl="2">
                        <b-form-input
                        v-model="form.target"
                        placeholder="Enter target"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group label="Hub Type:" label-cols-xl="2">
                        <el-select v-model="form.type" filterable placeholder="Select Type">
                            <el-option v-for="option in selectTypeOptions"
                                        :key="option.hub_type_id"
                                        :label="option.hub_type_name"
                                        :value="option.hub_type_id">
                            </el-option>
                        </el-select>
                    </b-form-group> 
                </b-col>
                <b-col md="12" cols="12">
                    <b-button type="submit" native-type="submit" variant="primary" class="float-right">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-card>
</template>
<script>
    import { Option, Select, Button, FormItem } from 'element-ui'
    import {axios, services, getHeader, swal } from '@/assets/js/httpImports.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    
    export default {
        name: 'edit-hub-details-form',
        mixins: [notifyFunctionMixin],
        components: {
            [Option.name]: Option,
            [Select.name]: Select,
            [Button.name]: Button,
            [FormItem.name]: FormItem,
        },
        data() {
            return {
                form: {
                    name: '',
                    hub_manager: '',
                    address: '',
                    target: '',
                    type: '',
                },
                selectTypeOptions: [],
                selectHubManagerOptions: []
            }
        },
        created() {
            axios.get(services.hub + 'hubs/' + this.$route.params.id ,{ headers: getHeader() })
            .then ( response => {
                if (response.status === 200)
                {
                    this.form.name                                  = response.data.data.hub_name
                    this.form.hub_manager                           = response.data.data.hub_manager.id
                    this.form.address                               = response.data.data.hub_address
                    this.form.target                                = response.data.data.hub_target.toLocaleString(undefined, {minimumFractionDigits: 2});
                    this.form.type                                  = response.data.data.hub_type.hub_type_id
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Show Hub")                
            });
            this.hubTypeList();
            this.hubManagerList();
        },
        methods: {
            close() {
                if(this.$route.params.token)
                {
                    // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                    window.history.back();
                    window.close();
                }
                else
                {
                    this.$router.back();
                }
            },
            updateData(){
                const postData = {
                    hub_type_id: this.form.type,
                    user_id: this.form.hub_manager,
                    hub_name: this.form.name,
                    hub_address: this.form.address,
                    hub_target: parseFloat(this.form.target),
                }

                axios.put(services.hub + 'hubs/' + this.$route.params.id , postData ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.$notify({
                        message:
                            '<b>Hub : ' + response.data.data.hub_name + '</b> - Successfully Updated.',
                        timeout: 10000,
                        icon: 'ni ni-bell-55',
                        type: 'default',
                        });

                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Edit Hub")
                });

            },
            hubTypeList() {
                axios.get(services.hub + 'setup/hub_type', { headers: getHeader() })
                .then(response => {
                    this.selectTypeOptions = response.data.data
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
                });
            },
            hubManagerList() {
                axios.get(services.access_control + 'user_list_by_role/hub manager', { headers: getHeader() })
                .then(response => {
                    this.selectHubManagerOptions = response.data.data
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing Hub Listing failed: " + error.response.data.message) 
                });
            },
        }
    }
</script>